import React, { useState } from "react";
import BrandRankingHelmet from "./components/BrandRankingHelmet";
import PeriodTabs from "./components/PeriodTabs";
import DayRankingPage from "./components/DayRankingPage";
import WeekRankingPage from "./components/WeekRankingPage";
import MonthRankingPage from "./components/MonthRankingPage";
import iconWave from "../../assets/icon_wave.svg";

import "./BrandRanking.css";
import { webappURL } from "../../util/url";
import PropTypes from "prop-types";

/**
 * 브랜드 랭킹 페이지
 * @returns {Element}
 * @constructor
 */
export default function BrandRanking({ hostname }) {
  const [period, setPeriod] = useState("1d");

  const now = new Date();
  const hourLabel = `${now.getHours()}시 기준`;

  const metaTitle =
    "브랜드 랭킹 | 후루츠패밀리 - 패션러버들의 중고거래 커뮤니티";
  const metaDescription =
    "지금 패션 러버들이 가장 주목하고 있는 브랜드가 궁금하다면? 후루츠패밀리 브랜드 랭킹에서 트렌드를 확인하세요. 구하기 힘든 디자이너 브랜드부터 감도 깊은 빈티지 - 세컨핸드까지, 모두 한눈에.";
  const metaImage = `${webappURL(hostname)}/logo512.png`;
  const metaUrl = `${webappURL(hostname)}/brand-ranking`;

  return (
    <section className="BrandRanking container">
      <BrandRankingHelmet
        metaTitle={metaTitle}
        metaDescription={metaDescription}
        metaUrl={metaUrl}
        metaImage={metaImage}
      />

      <h1 className="sr-only">
        지금 패션 러버들이 주목하는 브랜드 (brand pulse)
      </h1>
      <div>
        <p className="BrandRanking-subtitle">
          지금 패션 러버들이 주목하는 브랜드{" "}
        </p>
        <div className="BrandRanking-title-wrapper">
          <p className="BrandRanking-title">brand pulse</p>
          <img src={iconWave} alt="" />
        </div>
      </div>
      <p className="BrandRanking-desc">
        매 순간 변화하는 브랜드 랭킹을 통해
        <br />
        새로운 브랜드를 발견해 보세요.
      </p>
      <div className="BrandRanking-time">
        <span className="BrandRanking-time-dot" /> 오늘 {hourLabel}
      </div>

      <PeriodTabs activePeriod={period} onChange={setPeriod} />

      <div className="BrandRanking-content">
        {period === "1d" && <DayRankingPage />}
        {period === "1w" && <WeekRankingPage />}
        {period === "1m" && <MonthRankingPage />}
      </div>
    </section>
  );
}

BrandRanking.propTypes = {
  hostname: PropTypes.string.isRequired,
  userAgent: PropTypes.string.isRequired,
};
